// noinspection JSUnusedGlobalSymbols

import * as React from 'react'
import { ReactElement } from 'react'
import { getFocusStyle, getTheme, IListProps, ITheme, List, mergeStyleSets } from '@fluentui/react'

const theme: ITheme = getTheme()
export const baseListStyles = mergeStyleSets({
    listContainer: { rowGap: '0 !important' },
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            padding: theme.spacing.s1,
            margin: '0 1px -1px 1px',
            borderBottom: `1px solid ${theme.palette.themeLighter}`,
            borderTop: `1px solid ${theme.palette.themeLighter}`,
            userSelect: 'none',
            selectors: {
                '&:not(.is-dragging):hover': { background: theme.palette.themeLighterAlt },
                '&.is-selected': {
                    background: theme.palette.themeLighter,
                    border: '1px solid ' + theme.palette.themePrimary,
                    margin: '0 0 -1px 0',
                    overflow: 'hidden',
                    zIndex: 1,
                },
                '&.is-selected > *': {
                    overflow: 'visible',
                },
                '&.is-dragged': {
                    opacity: 0.5,
                    background: theme.palette.themeLighter,
                },
            },
        },
    ],
    overflowCell: { minWidth: 0 },
})

type Props<I> = Omit<IListProps<I>, 'onRenderCell' | 'children'> & {
    children: (item?: I, index?: number) => ReactElement | JSX.Element
}

export default function BaseList<I>(props: Props<I>): ReactElement {
    return (
        <List<I> {...props} onRenderCell={(item?: I, index?: number) => props.children(item, index)}>
            {undefined}
        </List>
    )
}
